import { IntroScreen } from '@/assets/images';
import CSS from './Instruction.module.css';

type InstructionProps = {
  translations: Record<string, string>;
};

const Instruction = ({ translations }: InstructionProps) => (
  <div className={CSS.instructionStep}>
    <h1 className={CSS.instructionTitle}>{translations.instructionstitle}</h1>
    <img src={IntroScreen} alt="intro screen" className={CSS.instructionImage} loading="lazy" />
  </div>
);

export default Instruction;
